let baseUrl
if (process.env.NODE_ENV == 'development') {
  baseUrl = 'http://10.6.0.146:8080'
  baseUrl = 'http://192.168.1.106:8080'
  baseUrl = 'http://10.102.7.62:5000'
} else if (process.env.NODE_ENV == 'production') {
  baseUrl = 'http://103.235.230.235:8444'
}

exports.baseUrl = baseUrl